export default __webpack_public_path__ + "static/media/personalized.2a028398.svg";